import React, { useState } from 'react';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import DatePicker, { DateObject } from 'react-multi-date-picker';
import InputIcon from 'react-multi-date-picker/components/input_icon';
import 'react-multi-date-picker/styles/layouts/mobile.css';
import 'react-multi-date-picker/styles/colors/red.css';
import styles from './MyDatePicker.module.scss';

const MyDatePicker = ({ state, setState, objectKey }) => {
  const handleChange = (e) => {
    if (e === null) {
      setState({ ...state, [objectKey]: '' });
      return;
    }

    setState({ ...state, [objectKey]: e.toString() });
  };

  return (
    <>
      <DatePicker
        render={<InputIcon className={styles.inputDate} />}
        className="red"
        maxDate={new DateObject({ calendar: persian }).add(0, 'days')}
        calendar={persian}
        locale={persian_fa}
        calendarPosition="bottom-right"
        format="YYYY/MM/DD"
        value={state[objectKey]}
        onChange={handleChange}
      />
    </>
  );
};

export default MyDatePicker;
